import React from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import {
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Paper as MuiPaper,
  Typography,
  Button,
  Box,
} from "@mui/material";
import { spacing } from "@mui/system";
import { SUPPORT_APP_GAME_CREATE } from "../../constants";
import HomeIcon from "@mui/icons-material/Home";
import { ServerDataGrid } from "../../components/CustomDataGrid";
import useAuth from "../../hooks/useAuth";
import { checkPermissions } from "../../utils/checkPermissions";

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const columns = [
  {
    accessorKey: "id",
    filterVariant: "text",
    header: "ID",
    operator: "equals",
  },
  {
    accessorKey: "name",
    filterVariant: "text",
    header: "Name",
    operator: "equals",
  },
  {
    accessorKey: "appId",
    filterVariant: "text",
    header: "App ID",
    operator: "equals",
  },
];

function GamesTable() {
  const navigate = useNavigate();

  return (
    <ServerDataGrid
      columns={columns}
      apiUrl={`/api/v1/games`}
      muiTableBodyRowProps={({ row }) => ({
        onClick: () => navigate(`/games/${row.original.id}`),
        sx: {
          cursor: "pointer",
        },
      })}
    />
  );
}

function GamesGrid() {
  const navigate = useNavigate();
  const { permissions } = useAuth();

  return (
    <React.Fragment>
      <Helmet title="Games" />
      <Typography variant="h3" gutterBottom display="inline">
        Games
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2} mb={6}>
        <Link component={NavLink} to="/">
          <HomeIcon />
        </Link>
        <Typography>Games</Typography>
      </Breadcrumbs>
      {checkPermissions([SUPPORT_APP_GAME_CREATE], permissions) && (
        <Box display="flex" justifyContent="right" pb={4}>
          <Button variant="contained" onClick={() => navigate("/games/new")}>
            Create Game
          </Button>
        </Box>
      )}
      <Paper>
        <GamesTable />
      </Paper>
    </React.Fragment>
  );
}

export default GamesGrid;
